import { jsx } from 'react/jsx-runtime';

const SvgArrowSmallUp = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M19 15.18v-2.62L12 6.7l-7 5.86v2.62l7-5.88 7 5.88Z" }) }));

export { SvgArrowSmallUp as default };
//# sourceMappingURL=ArrowSmallUp.es.js.map
